import { Link } from "react-router-dom";
import { categoryInfo } from "@/mocks/catalog";
import { movies } from "@/mocks/movies";

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {categoryInfo.map((cat) => {
        const count = movies.filter((m) => m.type === cat.key).length;
        return (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 hover:bg-accent-50/50"
          >
            <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-accent-500 group-hover:text-white">
              <i className={`${cat.icon} text-2xl`} aria-hidden="true" />
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-700">
                  {count} 部
                </span>
              </div>
              <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                {cat.desc}
              </p>
              <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-accent-600">
                进入分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}